import { State } from '../state';

export const StarfishDeviceSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    deviceRegistration: (state: State) => state.StarfishDevice,
};